import React from 'react';
import { motion } from 'framer-motion';

const problems = [
  {
    num: '01',
    title: 'Assets tracked in spreadsheets nobody trusts',
    desc: 'Which device is with which technician? What equipment is out for repair? When is the next maintenance due? Nobody knows for sure — and the spreadsheet is always a week behind.',
  },
  {
    num: '02',
    title: 'Support requests lost in email and Slack',
    desc: 'A field tech emails a request. Someone replies. It gets buried. Two days later nothing has happened and the tech emails again. There is no ticket, no owner, no SLA.',
  },
  {
    num: '03',
    title: 'No visibility into what is broken or where',
    desc: 'Management has no dashboard. No way to see what issues are open, what assets are flagged, or which sites are generating the most support volume.',
  },
  {
    num: '04',
    title: 'Accountability falls through the cracks',
    desc: 'When a request is not tracked in a system, it is easy for it to disappear. No one is formally assigned. No one is following up. Things get done when someone remembers.',
  },
  {
    num: '05',
    title: 'Asset lifecycle is invisible',
    desc: 'Procurement, deployment, maintenance, repair, and retirement all happen — but not in a connected way. Nobody can see the full history of an asset without hunting through emails and files.',
  },
  {
    num: '06',
    title: 'The team outgrows the spreadsheet but has no replacement',
    desc: 'At 50 employees a spreadsheet can work. At 150 it starts breaking. At 300 it is a liability. But standing up a proper system feels like a project nobody has time to own.',
  },
];

const HomeProblem = () => (
  <section id="problem" className="py-24" style={{ background: '#ffffff' }}>
    <div className="max-w-5xl mx-auto px-8 lg:px-16">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#16a34a' }}>The Problem</p>
        <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#052e16' }}>
          Spreadsheets and email were never built for this.
        </h2>
        <p className="text-base leading-relaxed max-w-2xl mb-14" style={{ color: '#374151' }}>
          Operations and IT managers at asset-heavy companies hit the same wall. The tools that worked at 30 people break at 150. Assets go missing. Requests fall through. Nobody has visibility. The fix is not another spreadsheet — it is a proper system.
        </p>
        <div className="grid md:grid-cols-2 gap-x-12 gap-y-10">
          {problems.map((p, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.06 }} className="flex items-start gap-5">
              <span className="text-2xl font-bold flex-shrink-0 leading-none mt-0.5" style={{ color: '#d1d5db' }}>
                {p.num}
              </span>
              <div>
                <p className="text-sm font-bold mb-1.5" style={{ color: '#111827' }}>{p.title}</p>
                <p className="text-sm leading-relaxed" style={{ color: '#6b7280' }}>{p.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);

export default HomeProblem;